import React, { useCallback, useState } from 'react';
import { Contact } from '../components/Contact';
import { CoreConcept } from '../components/CoreConcept';
import { Experience } from '../components/Experience';
import { Faq } from '../components/Faq';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';
import { Hero } from '../components/Hero';
import { Instructor } from '../components/Instructor';
import { Philosophy } from '../components/Philosophy';
import { PracticeApproach } from '../components/PracticeApproach';
import { Press } from '../components/Press';
import { SeoHead } from '../components/SeoHead';
import { ServicePanel } from '../components/ServicePanel';
import { Services } from '../components/Services';
import { Testimonials } from '../components/Testimonials';
import { WhyAlma } from '../components/WhyAlma';
import { Memberships } from '../components/Memberships';
import type { BookableId, BookingRequest } from '../types/booking';
import type { ServiceId } from '../types/copy';
export function Home() {
  const [openService, setOpenService] = useState<ServiceId | null>(null);
  const [bookingRequest, setBookingRequest] = useState<BookingRequest | null>(null);
  const closePanel = useCallback(() => setOpenService(null), []);
  const handleBook = useCallback((id: BookableId) => {
    setOpenService(null);
    setBookingRequest({
      id,
      key: Date.now()
    });
    window.setTimeout(() => {
      document.getElementById('contact')?.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }, 320);
  }, []);
  return <div className="min-h-screen w-full bg-cream" data-id="element-386" data-mp="28840qc06mrxr">
      <SeoHead data-id="element-387" data-mp="288vx3p1lstp3" />
      <Header data-id="element-388" data-mp="288dpjw9hqt1v" />
      <main id="main" data-id="element-389" data-mp="285rj5zyc6jl8">
        <Hero data-id="element-390" data-mp="239awzbap6fas" />
        <CoreConcept data-id="element-391" data-mp="239sqw19w0hfj" />
        <Experience data-id="element-392" data-mp="23acbjpqx9jx9" />
        <Services onOpen={setOpenService} data-id="element-393" data-mp="236y5a6f50qkj" />
        <Memberships onSelect={handleBook} data-id="element-394" data-mp="1z7xosuk4u00p" />
        <Instructor data-id="element-395" data-mp="1z6mlevulmua4" />
        <WhyAlma data-id="element-396" data-mp="1z98rss5r73qr" />
        <Philosophy data-id="element-397" data-mp="1u8l52iok592c" />
        <Testimonials data-id="element-398" data-mp="1u831t23h9ukx" />
        <Press data-id="element-399" data-mp="1u8uwmap93oa5" />
        <PracticeApproach data-id="element-400" data-mp="1uafqrz7nl57h" />
        <Faq data-id="element-401" data-mp="1kkz0h8gknlq7" />
        <Contact bookingRequest={bookingRequest} data-id="element-402" data-mp="1kk7ferklp6e6" />
      </main>
      <Footer data-id="element-403" data-mp="1kn3eij86q147" />
      <ServicePanel serviceId={openService} onClose={closePanel} onBook={handleBook} data-id="element-404" data-mp="1omc7vmzbbwz8" />
    </div>;
}